<template>
  <div class="modal fade" id="modal-waiting-list" tabindex="-1" data-bs-backdrop="static"
       data-bs-keyboard="false" aria-labelledby="modal-waiting-list" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content rounded shadow border-0">
        <div class="modal-header border-bottom">
          <h5 class="modal-title">Solicitação de encaixe</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-8">
                <div class="d-flex flex-column mb-8 fv-row fv-plugins-icon-container">
                  <label class="d-flex align-items-center fs-6 fw-semibold mb-2">
                    <span class="required">Profissional</span>
                  </label>
                  <input type="text" class="form-control form-control-solid" disabled :value="profName">
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex flex-column mb-8 fv-row fv-plugins-icon-container">
                  <label class="d-flex align-items-center fs-6 fw-semibold mb-2">
                    <span class="required">Forma de pagamento</span>
                  </label>
                  <select class="form-control form-control-solid" v-model="form.id_paymeth" required>
                    <option value="" selected disabled>--Selecione--</option>
                    <option :value="paymentMethod.id_paymeth" v-for="paymentMethod in paymentMethods">
                      {{paymentMethod.paymeth_name}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-3">
                <div class="d-flex flex-column mb-8 fv-row fv-plugins-icon-container">
                  <label class="d-flex align-items-center fs-6 fw-semibold mb-2">
                    <span class="required">CPF do paciente</span>
                  </label>
                  <input type="tel" class="form-control form-control-solid" maxlength="15" autofocus
                         v-mask="'###.###.###-##'" required
                         placeholder="Ex. 000.000.000/00" v-model="form.wl_cpf">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex flex-column mb-8 fv-row fv-plugins-icon-container">
                  <label class="d-flex align-items-center fs-6 fw-semibold mb-2">
                    <span class="required">Nome do paciente</span>
                  </label>
                  <input type="text" class="form-control form-control-solid" maxlength="225" required
                         placeholder="Ex. João da silva" v-model="form.wl_name">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex flex-column mb-8 fv-row fv-plugins-icon-container">
                  <label class="d-flex align-items-center fs-6 fw-semibold mb-2">
                    <span class="required">WhatsApp para contato</span>
                  </label>
                  <input type="tel" class="form-control form-control-solid"
                         v-mask="['(##) ####-####', '(##) #####-####']" required
                         placeholder="Ex. (99) 9 9999-9999" v-model="form.wl_phone">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex flex-column mb-8 fv-row fv-plugins-icon-container">
                  <label class="d-flex align-items-center fs-6 fw-semibold mb-2">
                    <span class="required">Data de nascimento</span>
                  </label>
                  <input type="tel" class="form-control form-control-solid"
                         v-mask="['##/##/####']" required
                         placeholder="DD/MM/YYYY" v-model="form.wl_dt_birth">
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="d-flex flex-column mb-8 fv-row fv-plugins-icon-container">
                  <label class="d-flex align-items-center fs-6 fw-semibold mb-2">
                    <span class="required">Observação</span>
                  </label>
                  <textarea class="form-control form-control-solid" v-model="form.wl_obs" maxlength="450"
                            placeholder="Escreva algo importante aqui."></textarea>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 text-end">
                <button class="btn btn-primary" type="submit">Solicitar encaixe</button>
              </div>
            </div>
          </form>

          <div v-if="this.localProfessional?.availability_dates?.length > 0">
            <br>
            <hr>
            <div class="rounded bg-primary bg-gradient p-lg-2 p-2" >
              <div class="section-title text-md-start text-center">
                <p class="text-white title-dark">
                  <span class="h5">
                    Este profissional está disponível para atendimentos {{ this.isOnline ? 'presenciais' : 'online' }}.
                  </span> <br>
                  <span class="text-white">
                    Caso prefira outro formato de atendimento, confira abaixo os horários disponíveis:
                  </span>
                </p>
              </div>
            </div>

            <Times
              :id_prof="this.localProfessional.id_prof"
              :id_place="this.localProfessional.id_place"
              :id_spec="this.specId"
              :id_city="this.isOnline ? this.localProfessional.id_city : null"
              :id_insurance="this.insurance?.id_insurance"
              :id_paymeth="this.schedule.paymentMethod.id_paymeth"
              :id_sched_father="null"
              :professional="this.localProfessional"
              @onClickDate="selectAvailability($event, this.localProfessional)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Swal from "sweetalert2";
import Modal from "../../helpers/modal";
import {mask} from 'vue-the-mask';
import Times from "@/views/components/Times.vue";
import Device from "@/helpers/device";
import { profileTo, placeColor } from "./paths";

export default {
  name: "WaitingListModal",
  components: {Times},
  props: ['professional', 'cityId', 'specId', 'isOnline'],
  directives: {
    mask,
  },
  data() {
    return {
      profName: null,
      specialties: [],
      paymentMethods: [],
      startEndDays: this.isMobile() ? 3 : 7,
      localProfessional: this.professional,
      form: {
        wl_name: '',
        wl_cpf: '',
        wl_phone: '',
        id_patient: '',
        id_user: '',
        id_insurance: '',
        id_paymeth: '',
        id_prof: '',
        id_spec: '',
        id_place: '',
        wl_obs: '',
        wl_dt_birth: '',
        id_city: '',
      }
    }
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
    schedule() {
      return this.$store.state.professionalProfile.schedule;
    },
    insurance() {
      return this.$store.state.professionalProfile.schedule.insurance;
    },
  },
  mounted() {
    Modal.onShow('#modal-waiting-list', () => {
      this.localProfessional = this.professional;
      this.getSpecialties();
      this.loadAvailabilityProfessional();
      this.resetForm();
      this.loadPaymentMethods();

      this.profName = this.localProfessional.prof_name;
      this.form.id_insurance = this.insurance?.id_insurance;
      this.form.id_paymeth = '';
      this.form.id_city = this.cityId;
      this.form.id_prof = this.localProfessional.id_prof;
      this.form.id_spec = this.specId;
      this.form.id_place = this.localProfessional.id_place;
      this.form.id_user = this.userAuth?.id_user;
    });
  },
  methods: {
    isMobile() {
      return Device.isMobile();
    },
    loadAvailabilityProfessional() {
      let params = {
        with_availability: true,
        start_end_days: this.startEndDays,
        id_prof: this.localProfessional.id_prof,
        id_place: this.localProfessional.id_place,
        id_city: this.isOnline ? this.cityId : null,
        id_spec: this.specId,
      };

      http.get(`/schedule/professionals/${this.localProfessional.id_prof}`, {params: params}).then((response) => {
        this.localProfessional.availability_dates = response.data.availability_dates;
      });
    },
    loadPaymentMethods() {
      http.get('/schedule/payment-methods', {
        params: {
          id_city: this.cityId,
          id_spec: this.specId,
          id_prof: this.localProfessional.id_prof,
        }
      }).then((response) => {
        this.paymentMethods = response.data;
      });
    },
    async selectAvailability(availabilityTime, professional) {
      if (this.isOnline) {
        let responseCity = await this.findCity();
        this.$store.commit('professionalProfile/selectCity', responseCity.data);
      } else {
        this.$store.commit('professionalProfile/selectCity', null);
      }

      let specialty = this.specialties.find(spec => Number(spec.id_spec) === Number(this.specId));
      this.$store.commit('professionalProfile/selectSpecialty', specialty);

      this.$store.commit('professionalProfile/selectAvailability', {professional, availabilityTime});

      this.$router.push(profileTo(this, 'paymentMethods', { professionalId: professional.id_prof, city: professional.id_city, place: professional.id_place, specialty: this.specId }));
    },
    findCity() {
      return http.get(`/cities/${this.localProfessional.id_city}`);
    },
    getSpecialties() {
      return http.get(`/professionals/${this.localProfessional.id_prof}/specialties`).then((specialties) => this.specialties = specialties.data);
    },
    onSubmit() {
      const saveWaitingList = (tryPrivaceSchedule) => {
        Swal.fire({
          title: 'Aguarde',
          allowOutsideClick: false,
        });
        Swal.showLoading();

        http.post(`/places/${this.form.id_place}/waiting-lists`, {...this.form, wl_accept_private_sched: tryPrivaceSchedule}).then(() => {
          this.resetForm()

          Modal.toggle('#modal-waiting-list');
          Swal.fire({
            title: 'Aeeeh!',
            text: "Paciente adicionado com sucesso.",
            icon: 'success',
            allowOutsideClick: false,
            confirmButtonText: 'Acessar minha conta',
            confirmButtonColor: placeColor(this),
          }).then(() => {
            this.$router.push('/schedules')
          });
        }).catch(e => {
          let message = e.response.data;
          if (e.response.data.message)
            message = e.response.data.message;

          Alert.error(message);
        });
      }

      let paymentMethod = this.paymentMethods.find(p => p.id_paymeth === this.form.id_paymeth);
      let msg = 'Em caso de urgência, a Ubbimed pode tentar agendar uma consulta particular, com preços acessíveis, na mesma especialidade, mas com outro profissional.';
      if (!paymentMethod.is_insurance) {
        msg = 'Em caso de urgência, a Ubbimed pode tentar agendar uma consulta com outro profissional.';
      }

      Swal.fire({
        html:
          `<p>${msg}</p>` +
          "<h3>Podemos tentar para você?</h3>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: placeColor(this),
        confirmButtonText: "Sim, preciso com urgência",
        cancelButtonText: "Não, quero tentar um encaixe",
      }).then((result) => {
        saveWaitingList(result.isConfirmed);
      });
    },
    resetForm() {
      this.form = {
        wl_name: '',
        wl_cpf: '',
        wl_phone: '',
        id_patient: '',
        id_user: '',
        id_insurance: '',
        id_paymeth: '',
        id_prof: '',
        id_spec: '',
        id_place: '',
        wl_obs: '',
        wl_dt_birth: '',
        id_city: '',
      }
    },
  }
}
</script>

<style scoped>

</style>